import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from 'interfaces/httpClient';
import {
	CaseApplications,
	CasesClient,
	CaseStatuses,
	CaseStatusFilter,
	PinnedCases,
	Step,
} from '@/interfaces';

class CaseApplicationsService {
	constructor(private client: AxiosInstance) {}

	async getAll({
		page,
		limit,
		search,
		progressStatusFilter,
	}: {
		page: number;
		limit: number;
		search?: string;
		progressStatusFilter?: CaseStatusFilter;
	}): Promise<HttpResponse<CasesClient>> {
		const params = {
			page,
			limit,
			...(search && { search }),
			...(progressStatusFilter && { progressStatusFilter }),
		};
		return this.client.get(`/cases_clients`, { params });
	}
	async getCaseById(id: string): Promise<HttpResponse<CaseApplications>> {
		return this.client.get(`/cases_clients/${id}`);
	}
	async getSteps(id: string): Promise<HttpResponse<Step[]>> {
		return this.client.get(`/cases_clients/${id}/steps`);
	}
	async getCaseStatuses(): Promise<HttpResponse<CaseStatuses[]>> {
		return this.client.get('/cases_clients/list-progress');
	}
	async getPinnedCases(): Promise<HttpResponse<PinnedCases[]>> {
		return this.client.get('/cases_clients/list-pinned-cases');
	}
	async togglePinCase(id: string): Promise<HttpResponse<{ data: string }>> {
		return this.client.put(`/cases_clients/${id}/pinned-case`);
	}
}

export const caseApplicationsService = new CaseApplicationsService(axiosClient);
